import { render, staticRenderFns } from "./list-product-slide-loader.vue?vue&type=template&id=07972434&scoped=true"
import script from "./list-product-slide-loader.vue?vue&type=script&lang=js"
export * from "./list-product-slide-loader.vue?vue&type=script&lang=js"
import style0 from "./list-product-slide-loader.vue?vue&type=style&index=0&id=07972434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07972434",
  null
  
)

export default component.exports